import styled from 'styled-components';

// keep user defined newlines etc
export const ModalFormInstructions = styled.div`
  margin-bottom: 1.5rem;
  white-space: pre-wrap;
`;
